import { UnoStoreHooks } from "@simulanisindia/ui";
import { Route, Routes } from "react-router-dom";
import { privateRoutes } from "../Routes/Routes";
import Private from "./Private";

const { useUnoSelector } = UnoStoreHooks;

const Layout = () => {
  const userData = useUnoSelector((state) => state.user);
  const isLoggedIn = userData.token.length > 0 ? true : false;

  return (
    <>
      <Routes>
        {isLoggedIn
          ? privateRoutes.map((route) => {
              const RenderComponent = route.element;
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <Private>
                      <RenderComponent />
                    </Private>
                  }
                />
              );
            })
          : ""}
      </Routes>
    </>
  );
};

export default Layout;
